module.exports = __webpack_public_path__ + "img/Weapon_10.6a47b757.png";